import { useContext } from "react"
import { MessagesContext } from "../context/messages"

export function useMessagesContext() {
  return useContext(MessagesContext)
}
